"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@emotion/core");

var js_brand_1 = require("@giphy/js-brand");

var react_1 = __importStar(require("react"));

var avatar_1 = __importDefault(require("../attribution/avatar"));

var verified_badge_1 = __importDefault(require("../attribution/verified-badge"));

var context_1 = require("./context");

var theme_1 = __importDefault(require("./theme"));

var channelMargin = 6;

var channelSearchHeight = function channelSearchHeight(theme) {
  return theme.searchbarHeight - channelMargin * 2;
};

var smallChannelSearchHeight = function smallChannelSearchHeight(theme) {
  return theme.smallSearchbarHeight - 3 * 2;
};

var animateAvatar = function animateAvatar(h) {
  return core_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nto {\n    width: ", "px;\n}\n"], ["\nto {\n    width: ", "px;\n}\n"])), h);
};

var Avatar = theme_1.default(avatar_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", "px;\n    margin: 0;\n    width: 0;\n    animation: ", " 100ms ease-in-out forwards;\n    @media (", ") {\n        height: ", "px;\n        animation: ", " 100ms ease-in-out forwards;\n    }\n"], ["\n    height: ", "px;\n    margin: 0;\n    width: 0;\n    animation: ", " 100ms ease-in-out forwards;\n    @media (", ") {\n        height: ", "px;\n        animation: ", " 100ms ease-in-out forwards;\n    }\n"])), function (props) {
  return channelSearchHeight(props.theme);
}, function (props) {
  return animateAvatar(channelSearchHeight(props.theme));
}, function (props) {
  return props.theme.condensedMediaQuery;
}, function (props) {
  return smallChannelSearchHeight(props.theme);
}, function (props) {
  return animateAvatar(smallChannelSearchHeight(props.theme));
});
var Username = theme_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: ", ";\n    display: flex;\n    align-items: center;\n    padding-left: ", "px;\n"], ["\n    background: ", ";\n    display: flex;\n    align-items: center;\n    padding-left: ", "px;\n"])), function (props) {
  return props.theme.mode === 'dark' ? js_brand_1.giphyCharcoal : js_brand_1.giphyWhite;
}, channelMargin);
var UsernamePill = theme_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background: ", ";\n    display: flex;\n    padding: 0 4px;\n    color: ", ";\n    font-family: interface, Helvetica Neue, helvetica, sans-serif;\n    font-weight: 600;\n    font-size: 12px;\n    align-items: center;\n    height: ", "px;\n    @media (", ") {\n        display: none;\n    }\n"], ["\n    background: ", ";\n    display: flex;\n    padding: 0 4px;\n    color: ", ";\n    font-family: interface, Helvetica Neue, helvetica, sans-serif;\n    font-weight: 600;\n    font-size: 12px;\n    align-items: center;\n    height: ", "px;\n    @media (", ") {\n        display: none;\n    }\n"])), js_brand_1.giphyWhiteSmoke, js_brand_1.giphyDarkCharcoal, function (props) {
  return channelSearchHeight(props.theme);
}, function (props) {
  return props.theme.condensedMediaQuery;
});

var SearchBarChannel = function SearchBarChannel(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b;
  var activeChannel = react_1.useContext(context_1.SearchContext).activeChannel;
  return activeChannel ? react_1.default.createElement(Username, {
    className: className
  }, react_1.default.createElement(Avatar, {
    user: activeChannel.user
  }), react_1.default.createElement(UsernamePill, {
    key: activeChannel.id
  }, react_1.default.createElement("div", null, "@", activeChannel.user.username), activeChannel.user.is_verified && react_1.default.createElement(verified_badge_1.default, {
    size: 14
  }))) : null;
};

exports.default = SearchBarChannel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;